<template lang="pug">
modal#cancel-subscription-modal(
  :buttonColor='buttonColor'
  :close='close'
  :close-button-label='$t("modal.cancelSubscription.closeButtonLabel")'
  :loading='loading'
  :process-button-label='$t("modal.cancelSubscription.processButtonLabel")'
  :processButtonClass='"btn-danger"'
  :title='$t("modal.cancelSubscription.title")'
  @closed='onCloseModal'
  @opened='onOpenModal'
  @process='submit'
  ref='modal'
)
  p {{ $t('modal.cancelSubscription.message1') }}
    strong {{ $t('modal.cancelSubscription.planFree') }},
    | {{ $t('modal.cancelSubscription.message2') }}
    strong {{ $t('modal.cancelSubscription.youCanSend') }}.
  p {{ $t('modal.cancelSubscription.message3') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import BillingHttp from '@/services/BillingHttp';
import formHandler from '@/modules/account/common/formHandler';
import alert from '@/modules/account/common/alert';

export default {
  components: {
    Modal,
    ImageLoader,
  },
  data() {
    return {
      loading: true,
      close: false,
      buttonColor: true,
    };
  },
  computed: {
    modalTitle() {
      return this.title;
    },
  },
  methods: {
    onOpenModal() {
      this.loading = false;
    },
    onCloseModal() {
      this.organization = {};
      this.name = '';
      this.logo = '';
      this.close = false;
      this.loading = true;
    },
    submit() {
      formHandler.submit(this, () => BillingHttp.cancelSubscription(), {
        successHandler: (response) => {
          if (response.status === 204) {
            this.loading = false;
            this.close = true;
            alert.fireAlert(
              this.$t('modal.cancelSubscription.successMessage'),
              {
                classes: 'alert-success',
                styles:
                  'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
                icon: 'circle-check',
              }
            );
            this.$refs.modal.close();
            window.location.reload();
          }
        },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
#buttonColor
  background-color: #DC342B
</style>
